import { render, staticRenderFns } from "./productInquiryTypeTab.vue?vue&type=template&id=35835c44&scoped=true"
import script from "./productInquiryTypeTab.vue?vue&type=script&lang=js"
export * from "./productInquiryTypeTab.vue?vue&type=script&lang=js"
import style0 from "./productInquiryTypeTab.vue?vue&type=style&index=0&id=35835c44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35835c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35835c44')) {
      api.createRecord('35835c44', component.options)
    } else {
      api.reload('35835c44', component.options)
    }
    module.hot.accept("./productInquiryTypeTab.vue?vue&type=template&id=35835c44&scoped=true", function () {
      api.rerender('35835c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/child/productInquiryTypeTab.vue"
export default component.exports